import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { get } from 'lodash';

const Languages = ({ classes, dealInterest }) => {
  if (get(dealInterest, 'inventory_user.user.languages')) {
    return (
      <div className={classes.status}>
        <strong><FormattedMessage id="profile_page.languages"/></strong>
        <p>{get(dealInterest, 'inventory_user.user.languages').join(', ')}</p>
      </div>
    );
  }
  return <div />;
};

const styles = {
  status : {
    margin : '0px 0px 15px 25px',
    width  : 170,
  },
};

export default withStyles(styles)(Languages);
